import React, { useEffect } from 'react';
import { getPairStats } from './FunctionAutoTopology';

const LinkInfoModal = () => {
 const stats = getPairStats(); 
 
 const linkNames = {
    "1-1": "100K-100K",
    "1-2": "100K-30K",
    "2-2": "30K-30K",
    "1-3": "100K-3K",
    "2-3": "30K-3K",
    "3-4": "3K-100ПАБ",
    "other": "Другое",
    "3-3": "3K-3K",
    "4-4": "100ПАБ-100ПАБ"
  };

  // делим на группы
  const links = Object.entries(stats).filter(
    ([key, value]) => value > 0 && !["4-4","3-3"].includes(key)
  );

  const trains = Object.entries(stats).filter(
    ([key, value]) => value > 0 && ["4-4","3-3"].includes(key)
  );

 
  return (
    
    <div className="divCurrentLink" style={{ padding: "10px", fontSize: "16px" }}>
      {/* Линки */}
      {links.length > 0 && (
        <>
          <label style={{ color: "#d1d1d1", textShadow: "2px 2px 4px rgba(8, 8, 8, 1)" }}>
            Линки
          </label>
          <hr style={{ margin: "2px", color: "#ffe08aff" }} />
          <div>
            {links.map(([key, value]) => (
              <div
                key={key}
                style={{
                  color: "#cccccc",
                  fontSize: "13px",
                  marginBottom: "2px",
                  textShadow: "2px 2px 4px #222222ff"
                }}
              >
                {linkNames[key] || key}:{" "}
          <span style={{ color: "#7fe777", fontWeight: "bold",marginRight: '2px' }}>{value}</span>шт.
              </div>
            ))}
          </div>
        </>
      )}

      {/* Паровозы */}
     {/* Паровозы */}
{trains.length > 0 && (
  <>
    <label
      style={{
        color: "#d1d1d1",
        textShadow: "2px 2px 4px rgb(58, 58, 58)",
        marginTop: "5px",
        textShadow: "2px 2px 4px #222222ff",
        
      }}
    >
      Паровозы
    </label>
    <hr style={{ margin: "2px", color: "#f8f6f6ff" }} />
    <div>
      {trains.map(([key, value]) => (
        <div
          key={key}
          style={{
            color: "#cccccc",
            fontSize: "13px",
            marginBottom: "2px",
            textShadow: "2px 2px 4px #222222ff"
          }}
        >
          {linkNames[key] || key}:{" "}
          <span style={{ color: "#fa423cff", fontWeight: "bold",marginRight: '2px' }}>{value}</span>шт.
        </div>
      ))}
    </div>
  </>
)}
    </div>
  );
};




export default LinkInfoModal;